import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'discount',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET DISCOUNTS
    getDiscountsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // GET DISCOUNT
    getDiscountSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },

    // CREATE DISCOUNT
    createDiscountSuccess(state, action) {
      const record = action.payload;
      state.isLoading = false;
      state.data = [...state.data, record];
      state.error = false;
    },

    // UPDATE DISCOUNT
    updateDiscountSuccess(state, action) {
      state.record = action.payload;
      const updateRecord = map(state.data, (_record) => {
        if (_record.id === state.record.id) {
          return state.record;
        }
        return _record;
      });

      state.isLoading = false;
      state.data = updateRecord;
      state.params = { ...state.params };
      state.error = false;
    },

    // DELETE DISCOUNT
    deleteDiscountSuccess(state, action) {
      const { id } = action.payload;
      const deleteRecord = filter(state.data, (user) => user.id !== id);
      state.isLoading = false;
      state.data = deleteRecord;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },

    // REFRESH PARAMS
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getDiscounts(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/discount/', {
        params,
      });
      dispatch(slice.actions.getDiscountsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getDiscount(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/discount/${id}/`);
      dispatch(slice.actions.getDiscountSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createDiscount(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/discount/', record);
      dispatch(slice.actions.createDiscountSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function updateDiscount(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/discount/${id}/`, record);
      dispatch(slice.actions.updateDiscountSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function partialUpdateDiscount(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`/discount/${id}/`, record);
      dispatch(slice.actions.updateDiscountSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function deleteDiscount(id, restore = false) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/discount/${id}/`, { data: { restore } });
      dispatch(slice.actions.deleteDiscountSuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
